module.exports = __webpack_public_path__ + "media/images/icons/twotone/frown-cb1004e5d20327c1b30563d7fcfd83e8.svg";